import React, { useEffect, useState } from 'react'
import { useQuickAdd } from '../../../hooks/useQuickAdd'
import { useCart } from '../../../hooks/useCart'
import Options from './Options'
import PriceDisplay from '../../PriceDisplay'
import {getSizedImageUrl} from '@shopify/theme-images';
import getRoute from '../../../../scripts/utils/getRoute'

const getPriceObjFromVariantOrProduct = (prod) => ({
  // eslint-disable-next-line camelcase
  final_price: prod.price,
  // eslint-disable-next-line camelcase
  total_discount: prod.compare_at_price ? prod.compare_at_price - prod.price : 0,
  price: prod.compare_at_price ? prod.compare_at_price : prod.price,
  // eslint-disable-next-line camelcase
  price_varies: Boolean(prod.price_varies),
  // eslint-disable-next-line camelcase
  min_price: prod.min_price ? prod.min_price : prod.price
})


interface Props {
  dataSet: any;
}


const QuickAdd: React.FunctionComponent<Props> = ({ dataSet }: Props) => {
  const {addToCart} = useCart()
  const { product, setHandle, setSelectedOptions,  selectedOptions, currentVariant, stockMap } = useQuickAdd()

  const lowStock = Boolean(currentVariant && stockMap[currentVariant.id] === 'low')
  const close = () => setHandle(null)

  const langStrings = dataSet.langStrings ? dataSet.langStrings : ''

  const [quickAddLangStrings, setquickAddLangStrings] = useState({} as Record<string, string>)

  useEffect(() => {
    let parsedLangsStrings = {}
    try {
      parsedLangsStrings = JSON.parse(langStrings)
    } catch (e) {
      console.info(e)
    }
    setquickAddLangStrings(parsedLangsStrings)
  }, [])

  if (!product) {
    return <></>
  }

  const {lowStockText, inStockText, oosText, fullDetailsCta, title, atcText, pleaseSelectText } = quickAddLangStrings;

  const optionsRemaining = product.options.filter((option, index) => option && !selectedOptions[index])

  const singleOptionRemaining = optionsRemaining.length === 1 ? optionsRemaining[0].name : ''

  const pleaseSelectTextReplaced = pleaseSelectText ? pleaseSelectText.replace('{{ option_name }}', singleOptionRemaining) : '';

  const actText = currentVariant ?
    currentVariant.available ? atcText: oosText : pleaseSelectTextReplaced


  return (
    <div className="quick-add-popup-wrap">
      <button tabIndex={-1} className="quick-add-underlay" aria-label='close' onClick={close}></button>
      <aside className="quick-add-popup">
        <header
          className="quick-add-header">
          <h3>{ title }</h3>
          <button className="quick-add-close" type="button" onClick={close}>&times;</button>
        </header>
        <main className="quick-add-main">
          <div className="quick-add-image">
            <img width="182" height="272" src={getSizedImageUrl(product.images[1], '224x336')} alt={product.title}></img>
          </div>
          <div className="quick-add-info">
            <h4 className="quick-add-title"> { product.title }</h4>
            <PriceDisplay product={getPriceObjFromVariantOrProduct(currentVariant ? currentVariant : product) } />
            <Options
              selectedOptions={selectedOptions}
              product={product}
              stockMap={stockMap}
              onChange={setSelectedOptions} />
            { currentVariant && currentVariant.available ? (
              <>
                {lowStock ? (<div className="quick-add-stock colour-error">{lowStockText}</div>) : (<div className="quick-add-stock colour-green"> { inStockText }</div>) }
              </>
            ) : null }
            <button
              className="btn--atc btn btn--primary"
              type="button"
              disabled={!(currentVariant && currentVariant.available)}
              onClick={() => addToCart(
                [
                  {
                    id: currentVariant.id,
                    quantity: 1
                  }],
                true,
                close)
              }
            >{actText}
            </button>
            <div className="quick-add-full-details-wrap">
              <a href={`${getRoute()}${product.handle}`}>{ fullDetailsCta }</a>
            </div>
          </div>
        </main>
      </aside>
    </div>

  )


};

export default QuickAdd